import { BGM_CATALOG } from "../../audio/bgm/bgmCatalog.js";
import { playGameSound, SOUND_CATALOG } from "../../audio/gameSoundPlayer.js";
import { BgmCatalogSection } from "./BgmCatalogSection.js";

export function SoundCatalogScreen() {
  return (
    <main className="sound-catalog">
      <header className="sound-catalog-header">
        <p>開発用サウンドテスト</p>
        <h1>効果音カタログ</h1>
        <span>BGM {BGM_CATALOG.length}曲 · 効果音{SOUND_CATALOG.length}種 · 試聴できます</span>
      </header>
      <BgmCatalogSection />
      <section className="sound-catalog-grid" aria-label="効果音一覧">
        {SOUND_CATALOG.map(({ sound, name, description, actionUseCount }) => (
          <article className="sound-catalog-item" key={sound}>
            <div>
              <h2>{name}</h2>
              <p>{description}</p>
            </div>
            <button type="button" onClick={() => playGameSound(sound, actionUseCount)} aria-label={`${name}を試聴`}>
              試聴
            </button>
          </article>
        ))}
      </section>
    </main>
  );
}
